/**
 * scrollbarThinCx
 */
export const scrollbarThinCx = cx(
  "scrollbar scrollbar-w-1 scrollbar-thumb-accent scrollbar-track-background scrollbar-thumb-rounded-full"
)
